const Colyseus = require("colyseus.js");
const queryString = require("query-string");
let wsUrl =
  process.env.NODE_ENV == "development"
    ? "ws://localhost:2567"
    : "wss://" + window.location.host;
let client = new Colyseus.Client(wsUrl);

export default {
  install(Vue, { store }) {
    Vue.prototype.$colyseus = {
      client,
      room: undefined
    };

    if (!store) {
      throw new Error("Please provide vuex store.");
    }

    let myModule = {
      namespaced: true,
      mutations: {
        setState(state, object) {
          this.$forceUpdate = true;
          for (let keys in object) {
            state[keys] = object[keys];
          }
        }
      },
      getters: {
        isHost: state => {
          return state.playerById[state.sessionId].isHost;
        },
        clientWord: state => {
          return state.playerById[state.sessionId]["word"];
        },
        self: state => {
          return state.playerById[state.sessionId];
        }
      }
    };

    Vue.mixin({
      methods: {
        stateChange(room) {
          this.$colyseus.room = room;
          // console.log("etape 1");
          room.onStateChange.once(state => {
            // console.log("etape 2");
            myModule.state = JSON.parse(JSON.stringify(state));
            myModule.state.sessionId = room.sessionId;
            store.registerModule("colyseus", myModule);
            // console.log("state:", state.step);
            this.redirect(state.step, room);
            localStorage["clientId"] = room.sessionId;
          });
          room.onStateChange(state => {
            if (state.step != this.$store.state.step)
              this.redirect(state.step, room);
            this.$store.commit(
              "colyseus/setState",
              JSON.parse(JSON.stringify(state))
            );
            if (this.$options["onStateChange"])
              this.$options["onStateChange"](state);
          });
          room.onLeave(code => {
            if (code == 4093) {
              let params = queryString.stringify({
                error: "Plus assez de joueurs"
              });
              window.location.replace("/?" + params);
            } else if (code !== 1001) {
              let params = queryString.stringify({ error: "disconnected" });
              window.location.replace("/?" + params);
            }
          });
        },
        joinRoomById(roomId, options) {
          client
            .joinById(roomId, options)
            .then(room => {
              this.stateChange(room);
            })
            .catch(e => {
              console.error("join error", e);
              let params = queryString.stringify({ error: e });
              window.location.replace("/?" + params);
            });
        },
        createRoom(roomName, options) {
          client
            .create(roomName, options)
            .then(room => {
              this.stateChange(room);
            })
            .catch(e => {
              console.error("join error", e);
              let params = queryString.stringify({ error: e });
              window.location.replace("/?" + params);
            });
        },
        redirect(path, room, params) {
          this.$colyseus.room = room;
          let parameters = queryString.stringify({
            roomId: room.id,
            ...params
          });
          this.$router.push(`/${path}?${parameters}`);
        },
        sendMessageToRoom(type, message) {
          this.$colyseus.room.send(type, message);
        }
      },
      mounted() {}
    });
  }
};
